import axios from "axios";

export default axios.create({
    baseURL: "https://api.unsplash.com",
    headers:{
                Authorization: "Client-ID 10079b82022b0ea06ae2eeb0c0d1feea9807de18f344e7f57af5e98ca3779079"
            }
});